const ITEMS = [
  "Cognitive Browsing",
  "Semantic Search",
  "Financial Analysis",
  "Business Plan",
  "Voice Legal",
  "Legal Drafting",
  "Due Diligence",
  "Reputation",
  "Secure Communication",
];

export const Marquee = () => {
  const loop = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="marquee"
      className="relative border-y border-white/[0.06] py-6 overflow-hidden bg-[#0a0f1a]"
    >
      <div className="marquee-track">
        {loop.map((item, i) => (
          <span
            key={i}
            className="flex items-center whitespace-nowrap text-sm uppercase tracking-[0.22em] text-zinc-500 mx-12"
          >
            {item}
            <span className="ml-24 h-1.5 w-1.5 rounded-full bg-gradient-to-r from-blue-400 to-cyan-400" />
          </span>
        ))}
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-[#0a0f1a] to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-[#0a0f1a] to-transparent" />
    </div>
  );
};
